var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckLitewhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.6 41.6",
    style: {
      enableBackground: "new 0 0 41.6 41.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#4180E3;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61615",
    className: "st0",
    d: "M20.8,0L20.8,0c11.5,0,20.8,9.3,20.8,20.8c0,0,0,0,0,0l0,0c0,11.5-9.3,20.8-20.8,20.8 c0,0,0,0,0,0l0,0C9.3,41.6,0,32.3,0,20.8c0,0,0,0,0,0l0,0C0,9.3,9.3,0,20.8,0C20.8,0,20.8,0,20.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61616",
    className: "st1",
    d: "M13.8,21.6l4.7,4.8l11.6-11.6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLitewhite);
export default __webpack_public_path__ + "static/media/check-Litewhite.f1f6d852882e1cea175acfd890dcc56b.svg";
export { ForwardRef as ReactComponent };